import React from "react";
import styled from "styled-components";

// Parts
import { SectionTitle } from "./SectionTitle";

export const CustomerVoices = () => {
  return (
    <StyledDivRootContainer>
      <SectionTitle title="Customer's Voice" />
    </StyledDivRootContainer>
  );
};

const StyledDivRootContainer = styled.div`
  padding: 0 16px;
`;
